import { store } from "../Redux/store";
import { fetchDynamicToken } from "../Redux/Features/authSlice";

/**
 * Helper to get token from Redux or fetch if expired
 * @returns {Promise<string|null>} Token string or null
 */
export const getDynamicToken = async () => {
  const state = store.getState();
  const { token, expiry } = state.auth;
  const now = Date.now();

  // If token exists and is valid, return it
  if (token && expiry && now < expiry) {
    return token;
  }

  // Otherwise, dispatch thunk to fetch new token
  const result = await store.dispatch(fetchDynamicToken());

  if (fetchDynamicToken.fulfilled.match(result)) {
    return result.payload; // The token
  } else {
    console.error("Failed to fetch token:", result.error);
    return null;
  }
};
